import { CreateCollectionResult } from '../models/createCollectionResult';
import { ReadCollectionsResult } from '../models/readCollectionsResult';
import { ReadDataResult } from '../models/readDataResult';
import { Result } from '../models/result';
import { formatDate } from '../util';
import Service from './service';

/**
 * コレクションAPIを操作するクラスです。
 */
class CollectionService extends Service {
    /**
     * コレクション一覧を取得します。
     * @returns コレクション一覧を返します。
     */
    public async get() {
        const jwt = this.getJwt();
        const apiEndpoint = this.createApiEndpoint('read-collection');
        const params = {
            jwt_str: jwt
        }

        const result = await this.httpGet<ReadCollectionsResult>(apiEndpoint, params);
        const collections = result.collections;

        return collections;
    }

    /**
     * コレクションの作成を行います。
     * @param collectionName 作成するコレクション名を指定します。
     * @param timeZone タイムゾーンを指定します。(ex: +9:00)
     */
    public async create(collectionName: string, timeZone: string) {
        const jwt = this.getJwt();
        const apiEndpoint = this.createApiEndpoint('create-collection');
        const params = {
            jwt_str: jwt,
            collection_name: collectionName,
            time_zone: timeZone
        };

        const createCollectionResult = await this.httpPost<CreateCollectionResult>(apiEndpoint, params, null);

        return createCollectionResult;
    };

    /**
     * コレクションの削除を行います。
     * @param collectionName 削除するコレクションUUIDを指定します。
     * @param callback 削除処理のコールバックを指定します。
     */
    public async delete(collectionId: string) {
        const apiEndpoint = this.createApiEndpoint('delete-collection');
        const jwt = this.getJwt();

        const params = {
            jwt_str: jwt,
            collection_id: collectionId
        };

        const deleteResult = await this.httpPost<Result>(apiEndpoint, params);

        return deleteResult;
    }

    /**
     * コレクションにデータの追加を行います。
     * @param collectionId データを追加するコレクションIDを指定します。
     * @param postKey POST KEYを指定します。
     * @param data 追加するデータを指定します。
     * @returns データ追加結果を返します。
     */
    public async addData(collectionId: string, postKey: string, data: string) {
        const apiEndpoint = this.createApiEndpoint('add-data');
        const params = {
            collection_id: collectionId,
            post_key: postKey
        };

        const jsonData = JSON.parse(data);

        const result = await this.httpPost<Result>(apiEndpoint, params, jsonData);

        return result;
    }

    public async readData(collectionId: string, startDateTime: string, endDateTime: string) {
        const apiEndpoint = this.createApiEndpoint('read-data');
        const jwt = this.getJwt();

        const params = {
            collection_id: collectionId,
            jwt_str: jwt,
            start_dt_str: startDateTime,
            end_dt_str: endDateTime
        };

        const result = await this.httpGet<ReadDataResult>(apiEndpoint, params);

        return result;
    }
}

export default CollectionService;